import { render, staticRenderFns } from "./CommentListing.vue?vue&type=template&id=6892ec1f&scoped=true"
import script from "./CommentListing.vue?vue&type=script&lang=js"
export * from "./CommentListing.vue?vue&type=script&lang=js"
import style0 from "./CommentListing.vue?vue&type=style&index=0&id=6892ec1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6892ec1f",
  null
  
)

export default component.exports